import React from 'react';
import { Box, Typography } from '@mui/material';
import MovieCard from './MovieCard';
import RatingLegend from './RatingLegend';

const CommonMovies = ({ movies }) => {
  if (!movies || movies.length === 0) {
    return null;
  }

  return (
    <Box sx={{ my: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5" component="h3">
          Movies You Both Rated
        </Typography>
        <RatingLegend />
      </Box>
      <Box
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(2, 1fr)',
          sm: 'repeat(3, 1fr)',
          md: 'repeat(4, 1fr)',
          lg: 'repeat(5, 1fr)'
        }}
        gap={2}
      >
        {movies.map((movie) => (
          <MovieCard
            key={movie.tmdb_id}
            movie={{
              id: movie.tmdb_id,
              title: movie.title,
              poster_path: movie.poster_path,
              release_date: movie.release_date,
            }}
            userRating={movie.user_rating}
            kriticRating={movie.score}
            isDisplayOnly={true}
          />
        ))}
      </Box>
    </Box>
  );
};

export default CommonMovies;